import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import { Button, Card, CardContent, Dialog, Grid } from "@material-ui/core";
import ConfirmationModal from "../../Components/Modal/Modal";
import { useLocation, Redirect } from "react-router-dom";
import DropdownComponent from "../../Components/Dropdown/DropdownComponent";
import { deleteGoogleAccount, editGoogleAccount } from "../../Services/API/GoogleAccount";
import Signifier from "../../Components/Signifier";
import { StyledTextField } from "../../Components/TextField/TextField";

function GoogleAccountsDetailed() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      marginBottom: "50px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    sensitiveSection: {
      width: "100%",
      height: "25%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      paddingTop: "20px",
    },
    sensitiveButton: {
      [theme.breakpoints.down("sm")]: {
        maxWidth: "none",
        width: "100%",
      },
      width: "200px",
    },
    error: {
      color: theme.palette.error.main,
    },
  }));

  const classes = useStyles();

  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [showError, setShowError] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [keyName, setKeyName] = useState(location.state === undefined ? "" : location.state.name);
  const [googleType, setGoogleType] = useState("");
  const googleTypeId = location.state === undefined ? "" : location.state.googleTypeId;
  const [accountKey, setAccountKey] = useState(location.state === undefined ? "" : location.state.key);
  const [reCaptchaKey, setReCaptchaKey] = useState(location.state === undefined ? "" : location.state.pkey);
  const [processing, setProcessing] = useState(false);
  const dropdownObjects = location.state === undefined ? "" : location.state.allTypes;
  const [deleted, setDeleted] = useState(false);

  const data = {
    Id: location.state === undefined ? "" : location.state.id,
    GoogleTypeID: location.state === undefined ? "" : googleType.id,
    Name: keyName,
    Key: accountKey,
    Pkey: reCaptchaKey,
  };

  const callAPI = (func, responseMessage) => {
    setProcessing(true);
    func.then((res) => {
      setShowSignifier(true);
      if (res) {
        setResponseMessage(responseMessage);
        setShowError(false);
      } else {
        setShowError(true);
      }
      setProcessing(false);
    });
  };

  const callDelete = async () => {
    await deleteGoogleAccount(location.state.id).then((response) => {
      if (response) {
        setDeleted(true);
        return true;
      }
    });
    return true;
  };

  useEffect(() => {
    for (const i in dropdownObjects) {
      if (dropdownObjects[i].id === googleTypeId) {
        setGoogleType(dropdownObjects[i]);
      }
    }
  }, [dropdownObjects, googleTypeId]);

  if (location.state === undefined) {
    return <Redirect to="/googleaccounts" />;
  }

  if (deleted) {
    return <Redirect to="/googleaccounts" />;
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">Google Account</h1>
        <div className={classes.root}>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid xs={12} sm={12} item>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Key Name"
                      label="Key Name"
                      variant="standard"
                      fullWidth
                      required
                      value={keyName}
                      onChange={(e) => setKeyName(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DropdownComponent
                      currValue={googleType}
                      items={dropdownObjects}
                      property="name"
                      title="Account Type"
                      handleChange={(value) => setGoogleType(value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Account Key"
                      label="Account Key"
                      value={accountKey}
                      onChange={(e) => setAccountKey(e.target.value)}
                      variant="standard"
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="reCaptcha Private Key"
                      label="reCaptcha Private Key"
                      value={reCaptchaKey}
                      onChange={(e) => setReCaptchaKey(e.target.value)}
                      variant="standard"
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} container justifyContent="flex-end">
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() => callAPI(editGoogleAccount(data), "Account Saved")}
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <div className={classes.sensitiveSection}>
              <Grid item xs={12} sm={12} container justifyContent="space-between">
                <Button
                  className={classes.sensitiveButton}
                  type="submit"
                  variant="contained"
                  color="secondary"
                  onClick={() => setOpenModal(true)}
                >
                  Delete Account
                </Button>
              </Grid>
            </div>
          </Grid>
        </div>
      </div>
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <ConfirmationModal
          question="Delete this account permanently?"
          func={() => callAPI(callDelete(), "Account Deleted")}
          closeModal={() => setOpenModal(false)}
          processing={processing}
        />
      </Dialog>
    </>
  );
}

export default GoogleAccountsDetailed;
